import { Col, Divider, Form, Modal, Radio, Row } from "antd";
import BreadCrumb from "../../../components/BreadCrumb/BreadCrumb";
import { CardContainer } from "../../../components/Card/CardContainer";
import PageTitleNested from "../../../components/PageTitle/PageTitleNested";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import Input from "../../../components/Input/Input";
import Text from "../../../components/Text/Text";
import Button from "../../../components/Button/Button";
import { useEffect, useState } from "react";
import { color } from "../../../resource";
import { zoneDatasource } from "../../../datasource/ZoneDatasource";
import { payloadTeam } from "../../../entities/TeamEntity";
import Select from "../../../components/Select/Select";

export const CreateZone: React.FC = () => {
  const navigate = useNavigate();
  const [form] = useForm();
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const isEdit = pathSplit[3] !== "create";
  const [showModal, setModal] = useState(false);
  const location = useLocation();
  const data = location?.state?.row;
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;
  const [errMessege, setErrMessege] = useState<string>("");
  const [isErr, setIserr] = useState<boolean>(false);
  const [teamList, setTeamList] = useState<{ label: string; value: string; key: string }[]>([]);
  const [statusUsed, setStatusUsed] = useState<boolean>(false);
  const { setFieldsValue } = form;

  const getTeamList = async () => {
    const payload: payloadTeam = {
      page: 0,
      take: 0,
      company: company,
      status: "ACTIVE",
    };
    const { data } = await zoneDatasource.getAllTeam(payload);
    setTeamList(data || []);
    const newFormat = data.map((el: { teamName: string; teamId: string }) => {
      return {
        label: el.teamName,
        value: el.teamId,
        key: el.teamId,
      };
    });
    setTeamList(newFormat);
  };

  const onSubmit = async () => {
    const formValue = form.getFieldsValue(true);
    if (isEdit) {
      const payload = {
        zoneId: data.zoneId,
        company: data.company,
        zoneName: formValue.zoneName,
        teamId: formValue.teamId ? formValue.teamId : null,
        isActive: formValue.isActive,
        updateBy: `${userProfile.firstname} ${userProfile.lastname}`,
      };
      try {
        const res = await zoneDatasource.patchZone(payload);
        if (res.success) {
          setModal(false);
          setTimeout(() => {
            navigate(-1);
          }, 500);
        } else {
          setIserr(true);
          setErrMessege(res.developerMessage);
          setModal(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      const payload = {
        company: userProfile.company,
        zoneName: formValue.zoneName,
        teamId: formValue.team,
        isActive: true,
        createBy: `${userProfile.firstname} ${userProfile.lastname}`,
      };
      try {
        const res = await zoneDatasource.postZone(payload);
        if (res.success) {
          setModal(false);
          setTimeout(() => {
            navigate(-1);
          }, 200);
        } else {
          setIserr(true);
          setErrMessege(res.developerMessage);
          setModal(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const getValue = async () => {
    form.setFieldsValue({
      zoneName: data?.zoneName,
      isActive: data?.isActive,
      team: data?.team?.teamName || null,
      teamId: data?.team?.teamId || null,
    });
    const getCheckZone = await zoneDatasource.getCheckZone(data.zoneId);
    setStatusUsed(getCheckZone.statusUsed);
  };
  useEffect(() => {
    getTeamList();
    if (isEdit) {
      getValue();
    } else {
      form.setFieldsValue({
        zoneName: "",
      });
    }
  }, []);

  useEffect(() => {
    if (isErr) {
      form.validateFields(["zoneName"]);
    }
  }, [isErr, form]);

  const getRules = () => {
    const rules = [
      {
        required: true,
        message: "โปรดระบุชื่อเขต",
      },
      {
        max: 50,
        message: "*ชื่อข่าวสารต้องมีความยาวไม่เกิน 50 ตัวอักษร",
      },

      isErr
        ? {
            validator: async (_, value) => {
              if (isErr) {
                throw new Error(errMessege);
              }
            },
          }
        : {},
    ];
    return rules;
  };

  return (
    <CardContainer>
      <PageTitleNested
        title={isEdit ? "แก้ไขเขต" : "เพิ่มเขต"}
        showBack
        onBack={() => navigate(`/generalSettings/zoneSetting`)}
        customBreadCrumb={
          <BreadCrumb
            data={[
              { text: "รายการเขต", path: `/generalSettings/zoneSetting` },
              {
                text: isEdit ? "ข้อมูลเขต" : "เพิ่มเขต",
                path: window.location.pathname,
              },
            ]}
          />
        }
      />
      <Divider />
      <Form form={form} layout='vertical' onFinish={() => setModal(true)}>
        <Col>
          <Form.Item name='zoneName' label='ชื่อเขต ' rules={getRules()}>
            <Input placeholder='ระบุชื่อเขต' autoComplete='off' />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            name='team'
            label='ทีม'
            rules={[
              {
                required: false,
                message: "โปรดระบุทีม",
              },
            ]}
          >
            <Select
              data={teamList}
              placeholder='ระบุทีม'
              style={{ marginBottom: 8 }}
              onChange={(e) => form.setFieldsValue({ teamId: e })}
            />
          </Form.Item>
        </Col>
        {isEdit && (
          <Col>
            <Form.Item
              name='isActive'
              label='สถานะ'
              rules={[
                {
                  required: true,
                  message: "*โปรดระบุสถานะ",
                },
              ]}
            >
              <Radio.Group style={{ width: "100%" }}>
                <Row>
                  <Radio value={true}>เปิดใช้งาน</Radio>
                </Row>
                <Row>
                  <Radio value={false} disabled={statusUsed}>
                    ปิดการใช้งาน
                  </Radio>
                </Row>
                {statusUsed && (
                  <Text color='error' fontWeight={400} fontSize={12}>
                    (ไม่สามารถตั้งค่าสถานะ “ปิดการใช้งาน”
                    ได้เนื่องจากมีการใช้งานข้อมูลเขตกับการตั้งค่าอื่นๆ)
                  </Text>
                )}
              </Radio.Group>
            </Form.Item>
          </Col>
        )}

        <Divider />
        <Row justify='space-between' gutter={12}>
          <Col xl={3} sm={6}>
            <Button
              typeButton='primary-light'
              title='ยกเลิก'
              htmlType='submit'
              onClick={() => navigate(`/generalSettings/zoneSetting`)}
            />
          </Col>
          <Col xl={15} sm={6}></Col>
          <Col xl={3} sm={6}>
            <Button typeButton='primary' title='บันทึก' htmlType='submit' />
          </Col>
        </Row>
      </Form>
      {showModal && (
        <Modal
          centered
          open={showModal}
          closable={false}
          onOk={onSubmit}
          onCancel={() => setModal(false)}
          destroyOnClose
          cancelText={"ยกเลิก"}
          okText={"ยืนยัน"}
          cancelButtonProps={{ style: { color: color.primary, borderColor: color.primary } }}
        >
          <Text level={2}>{isEdit ? "ยืนยันบันทึกเขต" : "ยืนยันเพิ่มเขต"}</Text>
          <br />
          {isEdit ? (
            <>
              <Text level={5} color='Text3'>
                โปรดตรวจสอบรายละเอียดเขตอีกครั้งก่อนกดยืนยัน
              </Text>
              <br />
              <Text level={5} color='Text3'>
                เพราะอาจส่งผลต่อการแสดงผลข้อมูลในระบบ
              </Text>
            </>
          ) : (
            <Text level={5} color='Text3'>
              โปรดตรวจสอบรายละเอียดก่อนกดยืนยัน
            </Text>
          )}
        </Modal>
      )}
    </CardContainer>
  );
};
